import { render, staticRenderFns } from "./PasswordChangeConfirm.vue?vue&type=template&id=228af382&scoped=true"
import script from "./PasswordChangeConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeConfirm.vue?vue&type=script&lang=js"
import style0 from "./PasswordChangeConfirm.vue?vue&type=style&index=0&id=228af382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228af382",
  null
  
)

export default component.exports